import { createFileRoute } from '@tanstack/react-router'
import { ConnectedAppsScreen } from '@/features/connected-apps/connected-apps-screen'

/** The authenticated layout is the platform-admin guard for this page. */
export const Route = createFileRoute('/_authenticated/settings/connected-apps')({
  component: ConnectedAppsScreen,
})
